import { connect } from 'react-redux';
import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectDecoratedDeliveryOptions } from 'src/redux/delivery/selectors';
import type {
  DeliverySectionDispatchProps,
  DeliverySectionStateProps,
} from '../../components/DeliverySection/DeliverySection';
import { DeliverySection } from '../../components/DeliverySection/DeliverySection';

const mapStateToProps = (state: ReduxApplicationState): DeliverySectionStateProps => {
  const { delivery } = state;

  return {
    deliveryOptions: selectDecoratedDeliveryOptions(state),
    loading: delivery.deliveryZoneOptionsLoading || delivery.partnerDeliverySettingsLoading,
    partnerFreeDeliveryThreshold: delivery.partnerFreeDeliveryThreshold,
    partnerName: state.product.partner.name,
  };
};

const mapDispatchToProps = (): DeliverySectionDispatchProps => {
  return {
    onDetailsLinkClick: (ev: React.MouseEvent<HTMLAnchorElement>) => {
      sendGALinkClickEvent(ev, {
        event: 'custom_event_v2',
        event_name: 'select_content',
        event_details: 'link click',
        content_type: 'delivery information',
        item_id: 'delivery and returns details',
      });
    },
    onVisible: () => {
      sendGAEvent({
        event: 'custom_event_v2',
        event_name: 'view_content',
        event_details: undefined,
        content_type: 'delivery information',
        item_id: undefined,
      });
    },
  };
};

export const DeliverySectionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeliverySection);
